/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Br_History_Key_PumpsInputs */



/**
* | output |
* | --- |
* | "Pumps" |
*
* @param {Br_History_Key_PumpsInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const br_history_key_pumps = /** @type {((inputs?: Br_History_Key_PumpsInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Br_History_Key_PumpsInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Pumps")
	return /** @type {LocalizedString} */ ("Pompes")
});